import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks/use-pagination-query";
import { http } from "../../utils/http";

function fetchBannerList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/banners", baseUrl);

  if (params.title) {
    endpointUrl.searchParams.append("title", params.title);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.orderBy) {
    endpointUrl.searchParams.append("orderBy", params.orderBy);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.orderBy],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useBannerList(params = {}) {
  return usePaginationQuery(
    [
      "banners",
      params.title,
      params.status,
      params.from,
      params.to,
      params.orderBy,
    ],
    (paginationState) => fetchBannerList({ ...params, ...paginationState })
  );
}
async function addBanner(formData) {
  const data = await http(`/admin/banners`, {
    data: formData,
  });
  return data;
}

export function useAddBanner() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(addBanner, {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(["banners"]);
      setTimeout(() => {
        navigate("/banner-management/");
      }, 1500);
    },
  });
}

async function disableBanner(formData) {
  const data = await http(`/admin/banners/${formData?.id}/disable`, {
    data: formData,
    method: "PATCH",
  });
  return data;
}

export function useDisableBanner() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(disableBanner, {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries(["banners"]);
      setTimeout(() => {
        navigate("/banner-management/");
      }, 1500);
    },
  });
}

export function useUpdateBanner() {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const res = await http(`/admin/banners`, {
        method: "PUT",
        data: data,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        await queryClient.invalidateQueries(["banners"]);
        return res;
      },
    }
  );
}

async function deleteBanner(id) {
  const data = await http(`/admin/banners/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteBanner() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteBanner, {
    onSuccess: () => {
      queryClient.invalidateQueries(["banners"]);
      setTimeout(() => {
        navigate("/banner-management");
      }, 1500);
    },
  });
}

export async function fetchBannerDownload() {
  const { data } = await http(`/admin/banner-download`, {
    responseType: "blob",
  });

  return data;
}

export function useBannerDownload() {
  const { data, ...raResult } = useQuery(["banner-download"], () =>
    fetchBannerDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
